<template>
	<vx-card class="w-full">
		<input
			id="fileinputtk"
			type="file"
			accept=".csv"
			@change="readCSV($event, prospectsURLs)"
			style="display: none"
		/>
		<vs-popup
			:active.sync="showModifyURLPopup"
			:title="'Modification du prospect'"
		>
			<div style="width: 1000px">
				<vs-input class="w-full" v-model="modifiedURL" />
				<vs-button @click="modifyURL">Enregistrer</vs-button>
			</div>
		</vs-popup>
		<form-wizard
			style="width: 90vw"
			color="rgba(var(--vs-primary), 1)"
			:title="
				isEdit
					? 'Modification  de la prospection'
					: 'Création  de la prospection'
			"
			subtitle=""
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Terminer"
			@on-complete="onComplete"
		>
			<tab-content title="Methodologie" class="mb-5">
				<prospect-first-page :isEdit="$props.isEdit" ref="prospectFirstPage" />
			</tab-content>
			<tab-content title="Keywords" class="mb-5">
				<prospect-second-page
					:isEdit="$props.isEdit"
					ref="prospectSecondPage"
					:key="secondPageRefreshKey"
				/>
			</tab-content>
			<tab-content title="URLs" class="mb-5">
				<prospect-third-page-url
					:isEdit="$props.isEdit"
					ref="prospectThirdPage"
					:key="thirdPageRefreshKey"
				/>
			</tab-content>
			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-left">
					<wizard-button
						v-if="props.activeTabIndex > 0"
						@click.native="props.prevTab()"
						:style="props.fillButtonStyle"
						>Précédent</wizard-button
					>
				</div>
				<div class="wizard-footer-right">
					<div class="mb-5 text-right">
						<div v-if="$props.isEdit && props.activeTabIndex == 0">
							<vs-button
								color="success"
								@click.native="postProjectSave()"
								:style="props.fillButtonStyle"
								class="mr-2"
								>Mettre à jour</vs-button
							>
						</div>
					</div>
					<div class="flex">
						<wizard-button
							@click.native="exitPage()"
							:style="[props.fillButtonStyle, { background: '#FF0D0D' }]"
							color="danger"
							class="mr-2"
							>Annuler</wizard-button
						>

						<div>
							<wizard-button
								v-if="!props.isLastStep"
								@click.native="handleNextTab(props)"
								class="wizard-footer-right"
								:style="props.fillButtonStyle"
								>Suivant</wizard-button
							>
							<div v-else>
								<div v-if="newProspects.isLoadingLastStep"></div>
								<div v-else>
									<wizard-button
										color="success"
										@click.native="handleFinishTab()"
										class="wizard-footer-right finish-button"
										:style="props.fillButtonStyle"
										>{{
											$props.isEdit ? "Enregistrer" : "Lancer l'analyse"
										}}</wizard-button
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</form-wizard>
		<!--  -->
	</vx-card>
</template>

<script>
import store from "@/store/store";
import VueCookies from "vue-cookies";
import XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import TopKeywordEditor from "@/components/views/dashboard/keywords/TopKeywordEditor";
import ProspectSearch from "@/entities/ProspectSearch";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import KeywordsIdeasCard from "../../views/dashboard/prospection/KeywordsIdeasCard.vue";
import ProspectFirstPage from "../../../views/pages/prospection/ProspectFirstPage.vue";
import ProspectSecondPage from "../../../views/pages/prospection/ProspectSecondPageUrl.vue";
import ProspectThirdPageUrl from "../../../views/pages/prospection/ProspectThirdPageUrl.vue";

export default {
	name: "ProspectForm",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		chartParams: Object,
		isPercent: Boolean,
		type: String,
		isEdit: {
			type: Boolean,
			default: false,
		},
		projectId: {
			type: Number,
			default: 0,
		},
	},
	components: {
		FormWizard,
		TabContent,
		WizardButton,
		flatPickr,
		TopKeywordEditor,
		KeywordsIdeasCard,
		ProspectFirstPage,
		ProspectSecondPage,
		ProspectThirdPageUrl,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			isDisableSaveButton: true,
			prospectSearch: ProspectSearch.getFormFields(),
			keywordsIdeaLanguageCode: null,
			topKeywords: [],
			countIncorrectUrl: 0,
			topKeywordFromSuggestion: [],
			showModifyTopKeywords: true,
			country_list: [],
			search_engines: [],
			search_engines_langauges: [],
			prospectsURLs: [],
			prospectProjectDetails: {},
			runPrsopect_auto: true,
			activeTab: 0,
			isProspectTabDisable: false,
			isKeywordTabDisable: true,
			isProspectCollapseOpen: true,
			showAddURL: true,
			newUrl: "",
			invalidUrlMessage: "Commencez par 'http://www.' ou 'https://www.'",
			warningMessage: null,
			showModifyURLPopup: false,
			modifiedURL: "",
			modifiedURLIndex: null,
			showLastButton: false,
			//key
			secondPageRefreshKey: 0,
			thirdPageRefreshKey: 0,
		};
	},
	created() {
		//fetching with deafult values
		this.fetchSearchEngines();
		this.fetchSearchEnginesCountries(1);
		this.fetchSearchEnginesLanguages(1);
		this.keywordsIdeaKey++;
		if (this.$props.isEdit) {
			this.fetchProspectProjectDetails();
			this.fetchProspectsBysProjectDetails();
		}
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		// Your component's computed properties go here
		newProspects() {
			return store.state.newProspects;
		},
	},
	watch: {
		topKeywords: function (val) {
			this.keywordsIdeasCardKey++;
		},

		// "prospectSearch.language_id": function (val) {

		// },
		"prospectSearch.language_id": function (val) {
			this.keywordsIdeaLanguageCode = this.search_engines_languages.find(
				(language) => language.id === val
			).code;
		},
		"prospectSearch.search_engine_id": function (val) {
			this.fetchSearchEnginesCountries(val);
			this.fetchSearchEnginesLanguages(val);
			this.keywordsIdeaKey++;
		},

		prospectsURLs: function (data) {
			// for (let i = 0; i < data.length; i++) {
			// 	var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			// 	if (!pattern.test(data[i].url.toLowerCase()))
			// 		this.warningMessage = "L'url doit contenir https://www.";
			// 	else this.warningMessage = null;
			// }
			// // disable save button if there is no prospect
			// this.checkDisableSaveButton();
			// this.editProspectKey++;
			// this.warningMessagekey++;
			// this.isKeywordTabDisable = false;
			// this.isProspectCollapseOpen = false;
			// this.isProspectCollapseOpen = true;
		},
	},
	methods: {
		exitPage() {
			this.returnPrevRoute();
		},
		showLastButton() {
			this.showLastButton = true;
		},
		/**
		 * Handle the next tab click
		 * @param {Object} props
		 */
		handleNextTab(props) {
			this.activeTab++;
			let passValidate = false;
			if (props.activeTabIndex == 0) {
				this.secondPageRefreshKey++;
				passValidate = !this.$props.isEdit
					? this.$refs.prospectFirstPage.validateAllField()
					: true;
			} else if (props.activeTabIndex == 1) {
				passValidate = !this.$props.isEdit
					? this.$refs.prospectSecondPage.validateAllFields()
					: true;
				if (this.$props.isEdit) this.thirdPageRefreshKey++;
				// this.thirdPageRefreshKey++;
				if (passValidate)
					!this.$props.isEdit
						? this.$refs.prospectThirdPage.onClickCossover()
						: true;
			} else if (props.activeTabIndex == 2) {
			}
			if (passValidate) {
				props.nextTab();
			}
		},
		async postProjectSave() {
			try {
				this.prospectSearch["name"] = this.newProspects.name;
				this.prospectSearch["domain_activity"] =
					this.newProspects.domain_activity;
				this.prospectSearch["location_id"] = this.newProspects.location_id;
				this.prospectSearch["location_code"] = this.newProspects.location_code;
				this.prospectSearch["language_id"] = this.newProspects.language_id;
				this.prospectSearch["search_engine_id"] =
					this.newProspects.search_engine_id;
				this.prospectSearch["type"] = this.newProspects.type;
				let prospectSearchObject = new ProspectSearch(this.prospectSearch);
				// ADD USER_ID
				prospectSearchObject.user_id = this.activeUser.id;

				prospectSearchObject.user_id = this.activeUser.id;
				await prospectSearchObject.updateProject(this.prospectSearch.id);
				this.$vs.notify({
					title: "Succès",
					color: "success",
					text: "Le project a été modifié avec succès.",
				});
				// this.returnPrevRoute();
			} catch (e) {
				console.log(e);
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Le project n'a pas été modifié.",
				});
			}
		},
		/**
		 * Handle the finish tab click
		 */
		handleFinishTab() {
			this.onComplete();
		},
		/**
		 * Handle the onComplete event
		 */
		onComplete() {
			if (!this.$props.isEdit) {
				// checking if all the required fields are filled
				if (
					Array.isArray(this.newProspects.keywordList) &&
					Array.isArray(this.newProspects.selectedUrls)
				) {
					if (
						this.newProspects.name &&
						this.newProspects.domain_activity &&
						this.newProspects.keywordList.length > 0 &&
						this.newProspects.selectedUrls.length > 0
					) {
						this.submitProspectSearch();
						return;
					}
				}
				// if not all required fields are filled, show a warning message
				this.$vs.notify({
					title: "Echec",
					color: "danger",
					text: "Veuillez remplir tous les champs obligatoires",
				});
			} else {
				this.$vs.notify({
					title: "Attention",
					color: "warning",
					time: 6000,
					text: "N'oubliez pas de re lancer l'analyse pour avoir les nouveaux resultats effectués sur les modifications",
				});
				this.returnPrevRoute();
				return;
			}
		},
		getLanguageCodeForKeywordsIdea() {
			if (this.search_engines_languages) {
				let resposne_code = this.search_engines_languages.find(
					(language) => language.id === this.prospectSearch.language_id
				);

				return resposne_code.code;
			}
		},
		getLocationCodeForKeywordsIdea() {
			if (this.country_list) {
				let resposne_code = this.country_list.find(
					(location) => location.id === this.prospectSearch.country_id
				);
				return resposne_code.location_code;
			}
		},
		validateUrl(url) {
			var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			if (!pattern.test(url)) this.warningMessage = this.invalidUrlMessage;
			else this.warningMessage = null;
			return;
		},
		deleteAllProspects() {
			this.prospectsURLs = [];
		},
		handleTabChange(value) {
			// if (value == 1) this.isProspectTabDisable = true;
			this.activeTab = value;
		},
		hanldeNextTab() {
			this.activeTab++;
		},
		addUrls(urls) {
			for (let url of urls) {
				if (
					this.prospectsURLs.includes(url.url.toString().toLowerCase()) == false
				) {
					this.prospectsURLs.push({ url: url.url.toLowerCase() });
				}
			}
		},
		csvImport() {
			//console.log("csvImport");
			this.setLoading(true, "importButton");
			let inputFile = document.getElementById("fileinputtk");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, prospectsURLs) {
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addUrls;
			reader.onload = function (e) {
				let mergedURLs = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });
				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_URLs = XLSX.utils.sheet_to_json(
					workbook.Sheets[sheet_name_list[0]],
					{ header: 1 }
				);
				// //console.log("fetched_competitors", fetched_competitors)
				if (fetched_URLs.length > 0) {
					mergedURLs = [...prospectsURLs];
					// //console.log("mergedURLs", mergedURLs)
					mergedURLs =
						mergedURLs.length > 0 ? mergedURLs.map((url) => url.url) : [];
					fetched_URLs.forEach((row, index) => {
						if (row[0] && row[0] !== null) {
							if (!mergedURLs.includes(row[0])) {
								var pattern = /^(https?:\/\/)?(www\.)\S+$/;
								if (!pattern.test(url)) {
									this.countIncorrectUrl++;
									this.warningMessage = `${this.countIncorrectUrl} urls sont pas valides`;
								} else {
									if (index < 100)
										// if (["https", "http", "wwww"].includes(row.url))
										mergedURLs.push({ url: row[0] });
									else this.warningMessage = "Seulement 100 URLS sont importés";
								}
							}

							// //console.log("mergedURLs updated", mergedURLs)
						}
					});

					//console.log(mergedURLs);
					// let stringMergedKeywords = mergedURLs.join(',')

					callback(mergedURLs);
				}
			};

			this.setLoading(false, "importButton");
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedURLs updated 2", this.mergedURLs) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedURLs)
			 */
		},
		fetchSearchEnginesCountries(id) {
			ProspectSearch.getSearchEnginesCountryList(id, (err, res) => {
				this.country_list = res;
				//making default country as france
				this.prospectSearch.country_id = this.country_list.find(
					(country) => country.location_name === "France"
				).id;
				this.countryListKey++;
			});
		},
		fetchSearchEngines() {
			ProspectSearch.getSearchEngines((err, res) => {
				this.search_engines = res;
			});
		},
		fetchSearchEnginesLanguages(id) {
			ProspectSearch.getSearchEnginesLanguages(id, (err, res) => {
				this.search_engines_languages = res;
				//making default language as french
				this.prospectSearch.language_id = this.search_engines_languages.find(
					(language) => language.name === "French"
				).id;
				this.languageListKey++;
			});
		},
		/**
		 * Submit the prospect search
		 */
		async submitProspectSearch() {
			// assign prospects to prospectSearch
			let keywords = [],
				prospects = [];
			this.newProspects.keywordList.forEach((keyword) => {
				keywords.push({ keyword: keyword });
			});
			this.newProspects.selectedUrls.forEach((urlObj) => {
				console.log("urlObj", urlObj);
				prospects.push({
					url: "https://" + urlObj.domain.replaceAll("https://", ""),
				});
			});
			if (!this.prospectSearch) {
				this.prospectSearch = {};
			}

			if (prospects.length > 0)
				this.prospectSearch["prospect_list"] = prospects;
			if (keywords.length > 0) this.prospectSearch["keyword_list"] = keywords;
			this.prospectSearch["name"] = this.newProspects.name;
			this.prospectSearch["domain_activity"] =
				this.newProspects.domain_activity;
			this.prospectSearch["location_id"] = this.newProspects.location_id;
			this.prospectSearch["location_code"] = this.newProspects.location_code;
			this.prospectSearch["language_id"] = this.newProspects.language_id;
			this.prospectSearch["search_engine_id"] =
				this.newProspects.search_engine_id;
			this.prospectSearch["type"] = this.newProspects.type;
			let prospectSearchObject = new ProspectSearch(this.prospectSearch);
			// ADD USER_ID
			prospectSearchObject.user_id = this.activeUser.id;
			if (!this.$props.isEdit) {
				try {
					let response;
					if (this.newProspects.type == 3) {
						response = await prospectSearchObject.createSimpleProject();
					} else {
						response = await prospectSearchObject.createProject();
					}
					this.returnToProjectDetailRoute(response.insertId);
					this.$vs.notify({
						title: "Succès",
						color: "success",
						text: "Le project ajoute avec succès.",
					});
				} catch (e) {
					console.log(e);
					this.$vs.notify({
						title: "Echec",
						color: "danger",
						text: "Le project n'a pas été ajoute.",
					});
					return;
				}
			} else {
				prospectSearchObject.editProject(
					this.prospectSearch.id,
					(errCreatePS, ps_id) => {
						if (errCreatePS) {
							// NOTIFY FAILED
							this.$vs.notify({
								title: "Echec",
								color: "danger",
								text: "Le project n'a pas été ajoute.",
							});
							return;
						}
						if (ps_id) {
							this.returnPrevRoute();
							this.resetDataNewProjects();
							this.$vs.notify({
								title: "Succès",
								color: "success",
								text: "Le project ajoute avec succès.",
							});
						}
					}
				);
			}

			/*
			 * CREATE PROSPECTSEARCH
			 * ADD PROSPECTS
			 * ADD KEYWORDS
			 */

			//console.log("submitProspectSearch");
		},

		checkRequiredFields() {
			let requiredOk = true;
			if (this.showModifyTopKeywords == true) requiredOk = false;
			if (this.prospectsURLs.length < 1) requiredOk = false;
			if (this.topKeywords.length < 1) requiredOk = false;

			return requiredOk;
		},

		displayModifyTopKeywords() {
			this.showModifyTopKeywords = true;
			this.$refs.topKeywordsEditor.setTopKeywords();
		},
		onToogleSave(toogleSave) {
			this.isDisableSaveButton = !toogleSave;
			this.saveButtonKey++;
		},
		updateAndHideModifyTopKeywords(tks) {
			this.showModifyTopKeywords = false;

			this.topKeywords = tks;
			this.saveButtonKey++;
			this.keywordsIdeaKey++;

			this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		updateKeywordsFromSuggestion(tks) {
			this.topKeywordFromSuggestion = tks;
			this.saveButtonKey++;
			this.topKeywordsEditorKey++;
			// this.keywordsIdeaKey++;
			this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		checkDisableSaveButton() {
			if (this.topKeywords.length > 0 && this.prospectsURLs.length > 0)
				this.isDisableSaveButton = false;
			else this.isDisableSaveButton = true;
		},
		cancelAndHideModifyTopKeywords() {
			this.showModifyTopKeywords = false;
		},
		addURL(url) {
			var pattern = /^(https?:\/\/)?(www\.)\S+$/;
			if (!pattern.test(url)) {
				this.warningMessage = `${url} est pas valide. ${this.invalidUrlMessage}`;
			} else {
				if (url) {
					this.prospectsURLs.push({ url: url });
					this.newUrl = "";
				}
				this.showAddURL = false;
			}
		},
		displayAddUrl() {
			this.showAddURL = true;
		},

		updateURL(index, row) {
			this.modifiedURL = row;
			this.modifiedURLIndex = index;
			this.showModifyURLPopup = true;
		},
		modifyURL() {
			this.prospectsURLs[this.modifiedURLIndex].url = this.modifiedURL;
			this.urlTableKey++;
			this.validateUrl(this.modifiedURL);
			this.showModifyURLPopup = false;
		},
		async fetchProspectProjectDetails() {
			this.prospectSearch = await ProspectSearch.fetchProspectProjectDetails(
				this.$route.params.psId
			);
			// saving ion old and new prospects
			this.$store.dispatch("setOldProspects", {
				...this.prospectSearch,
				project_id: this.prospectSearch.id,
				selectedUrls: this.prospectSearch.prospect_list,
				keywordList: this.prospectSearch.keyword_list,
			});
			this.$store.dispatch("setNewProspects", {
				...this.prospectSearch,
				project_id: this.prospectSearch.id,
				selectedUrls: this.prospectSearch.prospect_list,
				keywordList: this.prospectSearch.keyword_list,
			});
		},
		async fetchProspectsBysProjectDetails() {
			this.prospectsURLs = await ProspectSearch.getProspectByProjectId(
				this.$route.params.psId
			);
			this.assignKeywordsTableHeader(this.prospectsURLs);
		},
		// async fetchKeywordsBysProjectDetails() {
		// 	this.prospectsURLs = await ProspectSearch.getProspectByProjectId(
		// 		this.$route.params.psId
		// 	);
		// 	console.log("message", this.prospectsURLs);
		// 	this.assignKeywordsTableHeader(this.prospectsURLs);
		// 	this.prospectsURLs = this.prospectsURLs.map((url) => url.url);
		// },
		assignKeywordsTableHeader(prospectsList) {
			// Flatten all keywords from all prospects into a single array
			const allKeywords = prospectsList.flatMap((prospect) =>
				prospect.keywords.map((keyword) => keyword)
			);
			// Object to store unique keywords and their corresponding objects
			const uniqueKeywordsMap = {};

			// Iterate through the object list
			allKeywords.forEach((obj) => {
				// Check if the keyword already exists in the map
				if (!uniqueKeywordsMap.hasOwnProperty(obj.keyword)) {
					// If it doesn't exist, add it to the map with its corresponding object
					uniqueKeywordsMap[obj.keyword] = obj;
				}
			});

			// Extract the unique objects from the map
			const uniqueObjects = Object.values(uniqueKeywordsMap);
			// Use Set to get unique keywords
			this.topKeywords = uniqueObjects;
			this.topKeywordsEditorKey++;
			// this.prospectsListKey++;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
		returnToProjectDetailRoute(ppid) {
			this.$router.push({
				name: "prospectsProjectDetails",
				params: { ppId: ppid },
			});
		},
		resetDataNewProjects() {
			this.$store.dispatch("setNewProspects", ProspectSearch.getFormFields());
			this.$store.dispatch("setOldProspects", ProspectSearch.getFormFields());
		},
	},
	beforeDestroy() {
		this.resetDataNewProjects();
	},
};
</script>

<style scoped>
.warning-panel {
	background-color: #ffe0b2; /* Light orange */
	color: #b71c1c; /* Dark red */
	padding: 10px;
	border: 2px solid #ff9800; /* Orange border */
	border-radius: 5px;
	margin-bottom: 10px;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}
</style>
